/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUserUserIdRouteImport } from './routes/_authenticated/user/$userId'
import { Route as AuthenticatedUserGuidGuidRouteImport } from './routes/_authenticated/user-guid/$guid'
import { Route as AuthenticatedUserUserIdIndexRouteImport } from './routes/_authenticated/user/$userId/index'
import { Route as AuthenticatedUserUserIdTipYourselfRouteImport } from './routes/_authenticated/user/$userId/tip-yourself'
import { Route as AuthenticatedUserUserIdSubscriptionsRouteImport } from './routes/_authenticated/user/$userId/subscriptions'
import { Route as AuthenticatedUserUserIdPayrollRouteImport } from './routes/_authenticated/user/$userId/payroll'
import { Route as AuthenticatedUserUserIdLivePayRouteImport } from './routes/_authenticated/user/$userId/live-pay'
import { Route as AuthenticatedUserUserIdEarningsRouteImport } from './routes/_authenticated/user/$userId/earnings'
import { Route as AuthenticatedUserUserIdEarlyPayRouteImport } from './routes/_authenticated/user/$userId/early-pay'
import { Route as AuthenticatedUserUserIdDocsRouteImport } from './routes/_authenticated/user/$userId/docs'
import { Route as AuthenticatedUserUserIdCardRouteImport } from './routes/_authenticated/user/$userId/card'
import { Route as AuthenticatedUserUserIdBankRouteImport } from './routes/_authenticated/user/$userId/bank'
import { Route as AuthenticatedUserUserIdActivityRouteImport } from './routes/_authenticated/user/$userId/activity'
import { Route as AuthenticatedUserUserIdLivePayIndexRouteImport } from './routes/_authenticated/user/$userId/live-pay/index'
import { Route as AuthenticatedUserUserIdCardIndexRouteImport } from './routes/_authenticated/user/$userId/card/index'
import { Route as AuthenticatedUserUserIdLivePayTransfersRouteImport } from './routes/_authenticated/user/$userId/live-pay/transfers'
import { Route as AuthenticatedUserUserIdLivePayCardInfoRouteImport } from './routes/_authenticated/user/$userId/live-pay/card-info'
import { Route as AuthenticatedUserUserIdLivePayCardDisputeRouteImport } from './routes/_authenticated/user/$userId/live-pay/card-dispute'
import { Route as AuthenticatedUserUserIdLivePayActivityRouteImport } from './routes/_authenticated/user/$userId/live-pay/activity'

const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUserUserIdRoute = AuthenticatedUserUserIdRouteImport.update({
  id: '/user/$userId',
  path: '/user/$userId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUserGuidGuidRoute =
  AuthenticatedUserGuidGuidRouteImport.update({
    id: '/user-guid/$guid',
    path: '/user-guid/$guid',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedUserUserIdIndexRoute =
  AuthenticatedUserUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdTipYourselfRoute =
  AuthenticatedUserUserIdTipYourselfRouteImport.update({
    id: '/tip-yourself',
    path: '/tip-yourself',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdSubscriptionsRoute =
  AuthenticatedUserUserIdSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdPayrollRoute =
  AuthenticatedUserUserIdPayrollRouteImport.update({
    id: '/payroll',
    path: '/payroll',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdLivePayRoute =
  AuthenticatedUserUserIdLivePayRouteImport.update({
    id: '/live-pay',
    path: '/live-pay',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdEarningsRoute =
  AuthenticatedUserUserIdEarningsRouteImport.update({
    id: '/earnings',
    path: '/earnings',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdEarlyPayRoute =
  AuthenticatedUserUserIdEarlyPayRouteImport.update({
    id: '/early-pay',
    path: '/early-pay',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdDocsRoute =
  AuthenticatedUserUserIdDocsRouteImport.update({
    id: '/docs',
    path: '/docs',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdCardRoute =
  AuthenticatedUserUserIdCardRouteImport.update({
    id: '/card',
    path: '/card',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdBankRoute =
  AuthenticatedUserUserIdBankRouteImport.update({
    id: '/bank',
    path: '/bank',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdActivityRoute =
  AuthenticatedUserUserIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedUserUserIdRoute,
  } as any)
const AuthenticatedUserUserIdLivePayIndexRoute =
  AuthenticatedUserUserIdLivePayIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedUserUserIdLivePayRoute,
  } as any)
const AuthenticatedUserUserIdCardIndexRoute =
  AuthenticatedUserUserIdCardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedUserUserIdCardRoute,
  } as any)
const AuthenticatedUserUserIdLivePayTransfersRoute =
  AuthenticatedUserUserIdLivePayTransfersRouteImport.update({
    id: '/transfers',
    path: '/transfers',
    getParentRoute: () => AuthenticatedUserUserIdLivePayRoute,
  } as any)
const AuthenticatedUserUserIdLivePayCardInfoRoute =
  AuthenticatedUserUserIdLivePayCardInfoRouteImport.update({
    id: '/card-info',
    path: '/card-info',
    getParentRoute: () => AuthenticatedUserUserIdLivePayRoute,
  } as any)
const AuthenticatedUserUserIdLivePayCardDisputeRoute =
  AuthenticatedUserUserIdLivePayCardDisputeRouteImport.update({
    id: '/card-dispute',
    path: '/card-dispute',
    getParentRoute: () => AuthenticatedUserUserIdLivePayRoute,
  } as any)
const AuthenticatedUserUserIdLivePayActivityRoute =
  AuthenticatedUserUserIdLivePayActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedUserUserIdLivePayRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRoute
  '/user-guid/$guid': typeof AuthenticatedUserGuidGuidRoute
  '/user/$userId': typeof AuthenticatedUserUserIdRouteWithChildren
  '/user/$userId/activity': typeof AuthenticatedUserUserIdActivityRoute
  '/user/$userId/bank': typeof AuthenticatedUserUserIdBankRoute
  '/user/$userId/card': typeof AuthenticatedUserUserIdCardRouteWithChildren
  '/user/$userId/docs': typeof AuthenticatedUserUserIdDocsRoute
  '/user/$userId/early-pay': typeof AuthenticatedUserUserIdEarlyPayRoute
  '/user/$userId/earnings': typeof AuthenticatedUserUserIdEarningsRoute
  '/user/$userId/live-pay': typeof AuthenticatedUserUserIdLivePayRouteWithChildren
  '/user/$userId/payroll': typeof AuthenticatedUserUserIdPayrollRoute
  '/user/$userId/subscriptions': typeof AuthenticatedUserUserIdSubscriptionsRoute
  '/user/$userId/tip-yourself': typeof AuthenticatedUserUserIdTipYourselfRoute
  '/user/$userId/': typeof AuthenticatedUserUserIdIndexRoute
  '/user/$userId/live-pay/activity': typeof AuthenticatedUserUserIdLivePayActivityRoute
  '/user/$userId/live-pay/card-dispute': typeof AuthenticatedUserUserIdLivePayCardDisputeRoute
  '/user/$userId/live-pay/card-info': typeof AuthenticatedUserUserIdLivePayCardInfoRoute
  '/user/$userId/live-pay/transfers': typeof AuthenticatedUserUserIdLivePayTransfersRoute
  '/user/$userId/card/': typeof AuthenticatedUserUserIdCardIndexRoute
  '/user/$userId/live-pay/': typeof AuthenticatedUserUserIdLivePayIndexRoute
}
export interface FileRoutesByTo {
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRoute
  '/': typeof AuthenticatedIndexRoute
  '/user-guid/$guid': typeof AuthenticatedUserGuidGuidRoute
  '/user/$userId/activity': typeof AuthenticatedUserUserIdActivityRoute
  '/user/$userId/bank': typeof AuthenticatedUserUserIdBankRoute
  '/user/$userId/docs': typeof AuthenticatedUserUserIdDocsRoute
  '/user/$userId/early-pay': typeof AuthenticatedUserUserIdEarlyPayRoute
  '/user/$userId/earnings': typeof AuthenticatedUserUserIdEarningsRoute
  '/user/$userId/payroll': typeof AuthenticatedUserUserIdPayrollRoute
  '/user/$userId/subscriptions': typeof AuthenticatedUserUserIdSubscriptionsRoute
  '/user/$userId/tip-yourself': typeof AuthenticatedUserUserIdTipYourselfRoute
  '/user/$userId': typeof AuthenticatedUserUserIdIndexRoute
  '/user/$userId/live-pay/activity': typeof AuthenticatedUserUserIdLivePayActivityRoute
  '/user/$userId/live-pay/card-dispute': typeof AuthenticatedUserUserIdLivePayCardDisputeRoute
  '/user/$userId/live-pay/card-info': typeof AuthenticatedUserUserIdLivePayCardInfoRoute
  '/user/$userId/live-pay/transfers': typeof AuthenticatedUserUserIdLivePayTransfersRoute
  '/user/$userId/card': typeof AuthenticatedUserUserIdCardIndexRoute
  '/user/$userId/live-pay': typeof AuthenticatedUserUserIdLivePayIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/user-guid/$guid': typeof AuthenticatedUserGuidGuidRoute
  '/_authenticated/user/$userId': typeof AuthenticatedUserUserIdRouteWithChildren
  '/_authenticated/user/$userId/activity': typeof AuthenticatedUserUserIdActivityRoute
  '/_authenticated/user/$userId/bank': typeof AuthenticatedUserUserIdBankRoute
  '/_authenticated/user/$userId/card': typeof AuthenticatedUserUserIdCardRouteWithChildren
  '/_authenticated/user/$userId/docs': typeof AuthenticatedUserUserIdDocsRoute
  '/_authenticated/user/$userId/early-pay': typeof AuthenticatedUserUserIdEarlyPayRoute
  '/_authenticated/user/$userId/earnings': typeof AuthenticatedUserUserIdEarningsRoute
  '/_authenticated/user/$userId/live-pay': typeof AuthenticatedUserUserIdLivePayRouteWithChildren
  '/_authenticated/user/$userId/payroll': typeof AuthenticatedUserUserIdPayrollRoute
  '/_authenticated/user/$userId/subscriptions': typeof AuthenticatedUserUserIdSubscriptionsRoute
  '/_authenticated/user/$userId/tip-yourself': typeof AuthenticatedUserUserIdTipYourselfRoute
  '/_authenticated/user/$userId/': typeof AuthenticatedUserUserIdIndexRoute
  '/_authenticated/user/$userId/live-pay/activity': typeof AuthenticatedUserUserIdLivePayActivityRoute
  '/_authenticated/user/$userId/live-pay/card-dispute': typeof AuthenticatedUserUserIdLivePayCardDisputeRoute
  '/_authenticated/user/$userId/live-pay/card-info': typeof AuthenticatedUserUserIdLivePayCardInfoRoute
  '/_authenticated/user/$userId/live-pay/transfers': typeof AuthenticatedUserUserIdLivePayTransfersRoute
  '/_authenticated/user/$userId/card/': typeof AuthenticatedUserUserIdCardIndexRoute
  '/_authenticated/user/$userId/live-pay/': typeof AuthenticatedUserUserIdLivePayIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error'
    | '/login'
    | '/portal'
    | '/user-guid/$guid'
    | '/user/$userId'
    | '/user/$userId/activity'
    | '/user/$userId/bank'
    | '/user/$userId/card'
    | '/user/$userId/docs'
    | '/user/$userId/early-pay'
    | '/user/$userId/earnings'
    | '/user/$userId/live-pay'
    | '/user/$userId/payroll'
    | '/user/$userId/subscriptions'
    | '/user/$userId/tip-yourself'
    | '/user/$userId/'
    | '/user/$userId/live-pay/activity'
    | '/user/$userId/live-pay/card-dispute'
    | '/user/$userId/live-pay/card-info'
    | '/user/$userId/live-pay/transfers'
    | '/user/$userId/card/'
    | '/user/$userId/live-pay/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/error'
    | '/login'
    | '/portal'
    | '/'
    | '/user-guid/$guid'
    | '/user/$userId/activity'
    | '/user/$userId/bank'
    | '/user/$userId/docs'
    | '/user/$userId/early-pay'
    | '/user/$userId/earnings'
    | '/user/$userId/payroll'
    | '/user/$userId/subscriptions'
    | '/user/$userId/tip-yourself'
    | '/user/$userId'
    | '/user/$userId/live-pay/activity'
    | '/user/$userId/live-pay/card-dispute'
    | '/user/$userId/live-pay/card-info'
    | '/user/$userId/live-pay/transfers'
    | '/user/$userId/card'
    | '/user/$userId/live-pay'
  id:
    | '__root__'
    | '/_authenticated'
    | '/error'
    | '/login'
    | '/portal'
    | '/_authenticated/'
    | '/_authenticated/user-guid/$guid'
    | '/_authenticated/user/$userId'
    | '/_authenticated/user/$userId/activity'
    | '/_authenticated/user/$userId/bank'
    | '/_authenticated/user/$userId/card'
    | '/_authenticated/user/$userId/docs'
    | '/_authenticated/user/$userId/early-pay'
    | '/_authenticated/user/$userId/earnings'
    | '/_authenticated/user/$userId/live-pay'
    | '/_authenticated/user/$userId/payroll'
    | '/_authenticated/user/$userId/subscriptions'
    | '/_authenticated/user/$userId/tip-yourself'
    | '/_authenticated/user/$userId/'
    | '/_authenticated/user/$userId/live-pay/activity'
    | '/_authenticated/user/$userId/live-pay/card-dispute'
    | '/_authenticated/user/$userId/live-pay/card-info'
    | '/_authenticated/user/$userId/live-pay/transfers'
    | '/_authenticated/user/$userId/card/'
    | '/_authenticated/user/$userId/live-pay/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  LoginRoute: typeof LoginRoute
  PortalRoute: typeof PortalRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user/$userId': {
      id: '/_authenticated/user/$userId'
      path: '/user/$userId'
      fullPath: '/user/$userId'
      preLoaderRoute: typeof AuthenticatedUserUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user-guid/$guid': {
      id: '/_authenticated/user-guid/$guid'
      path: '/user-guid/$guid'
      fullPath: '/user-guid/$guid'
      preLoaderRoute: typeof AuthenticatedUserGuidGuidRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user/$userId/': {
      id: '/_authenticated/user/$userId/'
      path: '/'
      fullPath: '/user/$userId/'
      preLoaderRoute: typeof AuthenticatedUserUserIdIndexRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/tip-yourself': {
      id: '/_authenticated/user/$userId/tip-yourself'
      path: '/tip-yourself'
      fullPath: '/user/$userId/tip-yourself'
      preLoaderRoute: typeof AuthenticatedUserUserIdTipYourselfRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/subscriptions': {
      id: '/_authenticated/user/$userId/subscriptions'
      path: '/subscriptions'
      fullPath: '/user/$userId/subscriptions'
      preLoaderRoute: typeof AuthenticatedUserUserIdSubscriptionsRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/payroll': {
      id: '/_authenticated/user/$userId/payroll'
      path: '/payroll'
      fullPath: '/user/$userId/payroll'
      preLoaderRoute: typeof AuthenticatedUserUserIdPayrollRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/live-pay': {
      id: '/_authenticated/user/$userId/live-pay'
      path: '/live-pay'
      fullPath: '/user/$userId/live-pay'
      preLoaderRoute: typeof AuthenticatedUserUserIdLivePayRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/earnings': {
      id: '/_authenticated/user/$userId/earnings'
      path: '/earnings'
      fullPath: '/user/$userId/earnings'
      preLoaderRoute: typeof AuthenticatedUserUserIdEarningsRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/early-pay': {
      id: '/_authenticated/user/$userId/early-pay'
      path: '/early-pay'
      fullPath: '/user/$userId/early-pay'
      preLoaderRoute: typeof AuthenticatedUserUserIdEarlyPayRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/docs': {
      id: '/_authenticated/user/$userId/docs'
      path: '/docs'
      fullPath: '/user/$userId/docs'
      preLoaderRoute: typeof AuthenticatedUserUserIdDocsRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/card': {
      id: '/_authenticated/user/$userId/card'
      path: '/card'
      fullPath: '/user/$userId/card'
      preLoaderRoute: typeof AuthenticatedUserUserIdCardRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/bank': {
      id: '/_authenticated/user/$userId/bank'
      path: '/bank'
      fullPath: '/user/$userId/bank'
      preLoaderRoute: typeof AuthenticatedUserUserIdBankRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/activity': {
      id: '/_authenticated/user/$userId/activity'
      path: '/activity'
      fullPath: '/user/$userId/activity'
      preLoaderRoute: typeof AuthenticatedUserUserIdActivityRouteImport
      parentRoute: typeof AuthenticatedUserUserIdRoute
    }
    '/_authenticated/user/$userId/live-pay/': {
      id: '/_authenticated/user/$userId/live-pay/'
      path: '/'
      fullPath: '/user/$userId/live-pay/'
      preLoaderRoute: typeof AuthenticatedUserUserIdLivePayIndexRouteImport
      parentRoute: typeof AuthenticatedUserUserIdLivePayRoute
    }
    '/_authenticated/user/$userId/card/': {
      id: '/_authenticated/user/$userId/card/'
      path: '/'
      fullPath: '/user/$userId/card/'
      preLoaderRoute: typeof AuthenticatedUserUserIdCardIndexRouteImport
      parentRoute: typeof AuthenticatedUserUserIdCardRoute
    }
    '/_authenticated/user/$userId/live-pay/transfers': {
      id: '/_authenticated/user/$userId/live-pay/transfers'
      path: '/transfers'
      fullPath: '/user/$userId/live-pay/transfers'
      preLoaderRoute: typeof AuthenticatedUserUserIdLivePayTransfersRouteImport
      parentRoute: typeof AuthenticatedUserUserIdLivePayRoute
    }
    '/_authenticated/user/$userId/live-pay/card-info': {
      id: '/_authenticated/user/$userId/live-pay/card-info'
      path: '/card-info'
      fullPath: '/user/$userId/live-pay/card-info'
      preLoaderRoute: typeof AuthenticatedUserUserIdLivePayCardInfoRouteImport
      parentRoute: typeof AuthenticatedUserUserIdLivePayRoute
    }
    '/_authenticated/user/$userId/live-pay/card-dispute': {
      id: '/_authenticated/user/$userId/live-pay/card-dispute'
      path: '/card-dispute'
      fullPath: '/user/$userId/live-pay/card-dispute'
      preLoaderRoute: typeof AuthenticatedUserUserIdLivePayCardDisputeRouteImport
      parentRoute: typeof AuthenticatedUserUserIdLivePayRoute
    }
    '/_authenticated/user/$userId/live-pay/activity': {
      id: '/_authenticated/user/$userId/live-pay/activity'
      path: '/activity'
      fullPath: '/user/$userId/live-pay/activity'
      preLoaderRoute: typeof AuthenticatedUserUserIdLivePayActivityRouteImport
      parentRoute: typeof AuthenticatedUserUserIdLivePayRoute
    }
  }
}

interface AuthenticatedUserUserIdCardRouteChildren {
  AuthenticatedUserUserIdCardIndexRoute: typeof AuthenticatedUserUserIdCardIndexRoute
}

const AuthenticatedUserUserIdCardRouteChildren: AuthenticatedUserUserIdCardRouteChildren =
  {
    AuthenticatedUserUserIdCardIndexRoute:
      AuthenticatedUserUserIdCardIndexRoute,
  }

const AuthenticatedUserUserIdCardRouteWithChildren =
  AuthenticatedUserUserIdCardRoute._addFileChildren(
    AuthenticatedUserUserIdCardRouteChildren,
  )

interface AuthenticatedUserUserIdLivePayRouteChildren {
  AuthenticatedUserUserIdLivePayActivityRoute: typeof AuthenticatedUserUserIdLivePayActivityRoute
  AuthenticatedUserUserIdLivePayCardDisputeRoute: typeof AuthenticatedUserUserIdLivePayCardDisputeRoute
  AuthenticatedUserUserIdLivePayCardInfoRoute: typeof AuthenticatedUserUserIdLivePayCardInfoRoute
  AuthenticatedUserUserIdLivePayTransfersRoute: typeof AuthenticatedUserUserIdLivePayTransfersRoute
  AuthenticatedUserUserIdLivePayIndexRoute: typeof AuthenticatedUserUserIdLivePayIndexRoute
}

const AuthenticatedUserUserIdLivePayRouteChildren: AuthenticatedUserUserIdLivePayRouteChildren =
  {
    AuthenticatedUserUserIdLivePayActivityRoute:
      AuthenticatedUserUserIdLivePayActivityRoute,
    AuthenticatedUserUserIdLivePayCardDisputeRoute:
      AuthenticatedUserUserIdLivePayCardDisputeRoute,
    AuthenticatedUserUserIdLivePayCardInfoRoute:
      AuthenticatedUserUserIdLivePayCardInfoRoute,
    AuthenticatedUserUserIdLivePayTransfersRoute:
      AuthenticatedUserUserIdLivePayTransfersRoute,
    AuthenticatedUserUserIdLivePayIndexRoute:
      AuthenticatedUserUserIdLivePayIndexRoute,
  }

const AuthenticatedUserUserIdLivePayRouteWithChildren =
  AuthenticatedUserUserIdLivePayRoute._addFileChildren(
    AuthenticatedUserUserIdLivePayRouteChildren,
  )

interface AuthenticatedUserUserIdRouteChildren {
  AuthenticatedUserUserIdActivityRoute: typeof AuthenticatedUserUserIdActivityRoute
  AuthenticatedUserUserIdBankRoute: typeof AuthenticatedUserUserIdBankRoute
  AuthenticatedUserUserIdCardRoute: typeof AuthenticatedUserUserIdCardRouteWithChildren
  AuthenticatedUserUserIdDocsRoute: typeof AuthenticatedUserUserIdDocsRoute
  AuthenticatedUserUserIdEarlyPayRoute: typeof AuthenticatedUserUserIdEarlyPayRoute
  AuthenticatedUserUserIdEarningsRoute: typeof AuthenticatedUserUserIdEarningsRoute
  AuthenticatedUserUserIdLivePayRoute: typeof AuthenticatedUserUserIdLivePayRouteWithChildren
  AuthenticatedUserUserIdPayrollRoute: typeof AuthenticatedUserUserIdPayrollRoute
  AuthenticatedUserUserIdSubscriptionsRoute: typeof AuthenticatedUserUserIdSubscriptionsRoute
  AuthenticatedUserUserIdTipYourselfRoute: typeof AuthenticatedUserUserIdTipYourselfRoute
  AuthenticatedUserUserIdIndexRoute: typeof AuthenticatedUserUserIdIndexRoute
}

const AuthenticatedUserUserIdRouteChildren: AuthenticatedUserUserIdRouteChildren =
  {
    AuthenticatedUserUserIdActivityRoute: AuthenticatedUserUserIdActivityRoute,
    AuthenticatedUserUserIdBankRoute: AuthenticatedUserUserIdBankRoute,
    AuthenticatedUserUserIdCardRoute:
      AuthenticatedUserUserIdCardRouteWithChildren,
    AuthenticatedUserUserIdDocsRoute: AuthenticatedUserUserIdDocsRoute,
    AuthenticatedUserUserIdEarlyPayRoute: AuthenticatedUserUserIdEarlyPayRoute,
    AuthenticatedUserUserIdEarningsRoute: AuthenticatedUserUserIdEarningsRoute,
    AuthenticatedUserUserIdLivePayRoute:
      AuthenticatedUserUserIdLivePayRouteWithChildren,
    AuthenticatedUserUserIdPayrollRoute: AuthenticatedUserUserIdPayrollRoute,
    AuthenticatedUserUserIdSubscriptionsRoute:
      AuthenticatedUserUserIdSubscriptionsRoute,
    AuthenticatedUserUserIdTipYourselfRoute:
      AuthenticatedUserUserIdTipYourselfRoute,
    AuthenticatedUserUserIdIndexRoute: AuthenticatedUserUserIdIndexRoute,
  }

const AuthenticatedUserUserIdRouteWithChildren =
  AuthenticatedUserUserIdRoute._addFileChildren(
    AuthenticatedUserUserIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedUserGuidGuidRoute: typeof AuthenticatedUserGuidGuidRoute
  AuthenticatedUserUserIdRoute: typeof AuthenticatedUserUserIdRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedUserGuidGuidRoute: AuthenticatedUserGuidGuidRoute,
  AuthenticatedUserUserIdRoute: AuthenticatedUserUserIdRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ErrorRoute: ErrorRoute,
  LoginRoute: LoginRoute,
  PortalRoute: PortalRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
